module.exports = __webpack_public_path__ + "static/media/rpvideo.e588b2da.mp4";